import { Component } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { IGetEpisodesOfCare } from 'src/app/interfaces/IGetEpisodesOfCare';
import { EpisodeOfCareService } from 'src/app/services/episodeOfCare.service';
import { DischargeReportService } from 'src/app/services/dischargeReport.service';
import { VisitExpandComponent } from '../visit-expand/visit-expand.component';

@Component({
  selector: 'app-past-eoc',
  templateUrl: './past-eoc.component.html',
  styleUrls: ['./past-eoc.component.css'],
  standalone: false,
})
export class PastEocComponent {
  public expandComp = VisitExpandComponent;

  private destroy$ = new Subject<void>();

  isLoading = false;
  episodesOfCare: IGetEpisodesOfCare[] = [];

  customActions = [
    {
      iconType: 'icons:dischargeReport',
      tooltip: 'Discharge report',
      handler: (item: IGetEpisodesOfCare) =>
        this.dischargeReportService.open(item.id!),
      isVisible: (item: IGetEpisodesOfCare) => !!item?.isHospitalized,
    },
  ];

  constructor(
    private readonly eocService: EpisodeOfCareService,
    private readonly dischargeReportService: DischargeReportService
  ) {}

  ngOnInit() {
    this.eocService.pastEocLoadingSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: boolean) => {
        this.isLoading = data;
      });

    this.eocService.pastEocDataSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: IGetEpisodesOfCare[]) => {
        this.episodesOfCare = data;
      });

    this.eocService.getPastData();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}